import {EmployeeInOverview} from "@/data/entities/employee";
import {ReactNode} from "react";

export enum ClockedFilterStatus {
    ALL = "ALL",
    CLOCKED_IN = "CLOCKED_IN",
    CLOCKED_OUT = "CLOCKED_OUT",
}

export type EmployeeInDataTable = EmployeeInOverview & {
    options: ReactNode
};

export const employeesDataTableBaseUrl = (
    dashboardLocation: number,
    status: ClockedFilterStatus,
): string => {
    const dataUrl = new URL(`${process.env.BACKEND_API_BASE_URL}/employees/${dashboardLocation}/all`);
    dataUrl.searchParams.set("status", status);
    return dataUrl.toString()

    // const dataUrl = new URL(`${process.env.BACKEND_API_BASE_URL}/admin/students${search ? "/search" : ""}`);
    // dataUrl.searchParams.set("status", status);
    // return dataUrl.toString();
};
